import React, { useReducer } from 'react';

/**
 * @deprecated Use useState to manage modal display state.
 * There is an issue with this hook where dependent data does not update within the modal causing stale
 * data to be shown. Please use useState to manage modal display state instead of this hook.
 */
const useModal = handler => {
  const openModal = (type, payload) => handleModal({ type, payload });
  const dismissModal = () => openModal();
  const [modal, handleModal] = useReducer((state, { type, payload }) => handler(type, payload, dismissModal, state));
  return [modal, openModal, dismissModal];
};

export default useModal;
